/**
 * Locale hints taken from the browser rather than asked for. Both are
 * best-effort: a failure here must never block a form submission.
 */

/** IANA zone, e.g. "Asia/Kolkata". Used to time study reminders sensibly. */
export function browserTimezone(): string | undefined {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
  } catch {
    return undefined;
  }
}

/**
 * A first guess at the user's country from their locale, used only to
 * preselect the picker — the user always confirms it.
 */
export function guessCountry(): string {
  try {
    for (const tag of navigator.languages ?? [navigator.language]) {
      const region = new Intl.Locale(tag).maximize().region;
      if (region) return region.toUpperCase();
    }
  } catch {
    /* ignore — an empty guess just means an unselected picker */
  }
  return '';
}
